export const PRIVATE_NAVBAR_ICONS = {
  copyLink: 'home/navbar/Copy Link Icon.svg',
  notification: 'home/navbar/Notification Icon.svg',
  menu: 'home/navbar/Menu Icon.svg',
} as const;
